/**
 * The max number of FE subaccounts that can be created, including the primary subaccount name
 */
export const SUBACCOUNT_LIMIT = 4;
